import type { OnChainTokenSymbol } from './blockchain';

export const BUBBLE_GAME_WEB_URL = 'https://bubble.ggmomomo.com';

export function resolveBubbleGameLink(isWorldApp: boolean, worldAppLink: string | null): string | null {
  return isWorldApp ? worldAppLink : BUBBLE_GAME_WEB_URL;
}

export type SwapDeepLinkPreset = {
  inputSymbol: OnChainTokenSymbol;
  outputSymbol: OnChainTokenSymbol;
};

const SUPPORTED_DEEPLINK_TOKENS = new Set<OnChainTokenSymbol>([
  'WLD',
  'BBT',
  'GGMOMOMO',
]);

function isSupportedDeepLinkToken(value: string | null): value is OnChainTokenSymbol {
  return value !== null && SUPPORTED_DEEPLINK_TOKENS.has(value as OnChainTokenSymbol);
}

export function parseSwapDeepLink(search: string): SwapDeepLinkPreset | null {
  const params = new URLSearchParams(search);
  if (params.get('modal') !== 'swap') return null;

  const fromToken = params.get('fromToken');
  const toToken = params.get('toToken');

  return {
    inputSymbol: isSupportedDeepLinkToken(fromToken)
      ? fromToken
      : 'WLD',
    outputSymbol: isSupportedDeepLinkToken(toToken)
      ? toToken
      : 'BBT',
  };
}
